import { da, sv, nb, nl, nlBE, fi, enUS, is, enGB } from "date-fns/locale";

export type LocaleKey =
  | "en-US"
  | "da-DK"
  | "nl-NL"
  | "nl-BE"
  | "en-GB"
  | "fi-FI"
  | "is-IS"
  | "nb-NO"
  | "sv-SE";

export const localeMap = {
  "en-US": enUS,
  "da-DK": da,
  "nl-NL": nl,
  "nl-BE": nlBE,
  "en-GB": enGB,
  "fi-FI": fi,
  "is-IS": is,
  "nb-NO": nb,
  "sv-SE": sv,
};
